import { defineMessages } from "react-intl";

export const sectionMessages = defineMessages({
  allKeys: {
    id: "LhdR7g",
    defaultMessage: "All API keys",
    description: "api key page, TopNav destination link tooltip to the key list",
  },
  configurationDescription: {
    id: "zZ2CJ8",
    defaultMessage: "Credentials for outside systems such as an ERP or feed vendor",
    description: "configuration page, api keys entry description",
  },
  loadFailed: {
    id: "uk4iMP",
    defaultMessage: "The API keys could not be loaded. Reload the page to try again.",
    description: "api keys, read failed",
  },
  notFound: {
    id: "NWcd+5",
    defaultMessage: "This API key does not exist.",
    description: "api key detail, key not found",
  },
  saved: {
    id: "LmCIuU",
    defaultMessage: "Key saved",
    description: "api key, saved notification",
  },
  created: {
    id: "a3JztN",
    defaultMessage: "Key created",
    description: "api key, created notification",
  },
  revoked: {
    id: "OTxKFv",
    defaultMessage: "Key revoked",
    description: "api key, revoked notification",
  },
  secretDeleted: {
    id: "FIhK1u",
    defaultMessage: "Secret deleted",
    description: "api key, secret deleted notification",
  },
});

export const statusMessages = defineMessages({
  ACTIVE: {
    id: "SEUK9j",
    defaultMessage: "Active",
    description: "api key status",
  },
  EXPIRED: {
    id: "gDstW0",
    defaultMessage: "Expired",
    description: "api key status",
  },
  REVOKED: {
    id: "aRJqsN",
    defaultMessage: "Revoked",
    description: "api key status",
  },
});

export const accessMessages = defineMessages({
  readOnly: {
    id: "AePnwx",
    defaultMessage: "Read-only",
    description: "api key, pill and summary value for a key refused on every change",
  },
  readWrite: {
    id: "vZHkgg",
    defaultMessage: "Read and write",
    description: "api key detail summary, a key that may change what its permissions allow",
  },
  noAccess: {
    id: "40cUvg",
    defaultMessage: "No access",
    description: "api key detail summary, a revoked or expired key, which cannot authenticate",
  },
});

export const listMessages = defineMessages({
  createKey: {
    id: "8spT4d",
    defaultMessage: "Create key",
    description: "api key list, button",
  },
  label: {
    id: "r1wZcz",
    defaultMessage: "Label",
    description: "api key list, column",
  },
  status: {
    id: "zXS+v5",
    defaultMessage: "Status",
    description: "api key list, column",
  },
  permissions: {
    id: "q1BBC4",
    defaultMessage: "Permissions",
    description: "api key list, column",
  },
  lastUsed: {
    id: "eTvs+/",
    defaultMessage: "Last used",
    description: "api key list, column",
  },
  expires: {
    id: "jG5BYG",
    defaultMessage: "Expires",
    description: "api key list, column",
  },
  created: {
    id: "O72L82",
    defaultMessage: "Created",
    description: "api key list, column",
  },
  never: {
    id: "DvX8Fl",
    defaultMessage: "Never",
    description: "api key, last used or expiry: none",
  },
  permissionCount: {
    id: "AisZ+u",
    defaultMessage: "{count, plural, one {# permission} other {# permissions}}",
    description: "api key list, how many permissions a key has",
  },
  noPermissions: {
    id: "ZiiwVR",
    defaultMessage: "None",
    description: "api key list, a key with no permissions",
  },
  stale: {
    id: "Cjv56i",
    defaultMessage: "Unused for 90+ days",
    description: "api key list, flag on a key with no request in 90 days",
  },
  staleHint: {
    id: "/3e2Bw",
    defaultMessage:
      "This key has not made a request in 90 days or more. If nothing uses it any more, revoke it.",
    description: "api key, tooltip and detail note on a key unused for 90 days",
  },
  empty: {
    id: "pZv6Qd",
    defaultMessage:
      "No API keys yet. Create one to give an outside system, such as an ERP or a feed vendor, access to your store's API.",
    description: "api key list, empty",
  },
});

export const formMessages = defineMessages({
  createTitle: {
    id: "D6IfLt",
    defaultMessage: "Create API key",
    description: "api key create page title",
  },
  generalTitle: {
    id: "uskynT",
    defaultMessage: "Key",
    description: "api key form, card title",
  },
  label: {
    id: "zzqoTO",
    defaultMessage: "Label",
    description: "api key form, field",
  },
  labelHelp: {
    id: "j3b4f1",
    defaultMessage: 'Who holds it, such as "NetSuite ERP". Up to {max} characters.',
    description: "api key form, label help",
  },
  expiry: {
    id: "lYkmB3",
    defaultMessage: "Expires on",
    description: "api key form, field",
  },
  expiryHelp: {
    id: "w9ci0L",
    defaultMessage: "The key works through the end of this day. Leave empty for no expiry.",
    description: "api key form, expiry help",
  },
  expiryReactivates: {
    id: "cWhK2l",
    defaultMessage: "This key has expired. Set a later date, or clear it, to make it work again.",
    description: "api key form, expiry help on an expired key",
  },
  permissionsDescription: {
    id: "bEsCk+",
    defaultMessage:
      "What the key may do. You can only give permissions you have yourself, and never Manage apps.",
    description: "api key form, permissions card description",
  },
  fullAccess: {
    id: "ZAcZqv",
    defaultMessage: "Give this key every permission you can",
    description: "api key form, full access checkbox",
  },
  permissionDisabled: {
    id: "REyJTs",
    defaultMessage: "You do not have this permission, so you cannot give it to a key.",
    description: "api key form, tooltip on a permission the viewer lacks",
  },
  readOnly: {
    id: "uTuDcl",
    defaultMessage: "Read-only",
    description: "api key form, read-only switch label",
  },
  readOnlyHelp: {
    id: "8g1N9b",
    defaultMessage:
      "It can read what its permissions allow and change nothing: every change it tries is refused.",
    description: "api key form, read-only switch help",
  },
  readOnlyRevoked: {
    id: "mDpcgR",
    defaultMessage: "This key is revoked. It no longer works and cannot be changed.",
    description: "api key detail, notice on a revoked key",
  },
});

export const detailMessages = defineMessages({
  summary: {
    id: "FA3UlZ",
    defaultMessage: "Summary",
    description: "api key detail, card title",
  },
  access: {
    id: "aaoRcF",
    defaultMessage: "Access",
    description: "api key detail, fact label: read-only or read and write",
  },
  status: {
    id: "sI2x8+",
    defaultMessage: "Status",
    description: "api key detail, fact label",
  },
  created: {
    id: "hciCz9",
    defaultMessage: "Created",
    description: "api key detail, fact label",
  },
  lastUsed: {
    id: "DVC7dS",
    defaultMessage: "Last used",
    description: "api key detail, fact label",
  },
  revokedAt: {
    id: "BnoJRT",
    defaultMessage: "Revoked",
    description: "api key detail, fact label",
  },
  lastUsedHelp: {
    id: "w2IiJr",
    defaultMessage: "A UTC day, from the request log's daily totals; up to an hour behind.",
    description: "api key detail, last used help",
  },
  secretsTitle: {
    id: "Hy9s1u",
    defaultMessage: "Secrets",
    description: "api key detail, card title",
  },
  secretsDescription: {
    id: "6xNABg",
    defaultMessage:
      "To rotate without a gap: add a secret, give it to the holder, then delete the old one.",
    description: "api key detail, secrets card description",
  },
  secretEndingIn: {
    id: "/SMhDa",
    defaultMessage: "Secret ending in {lastFour}",
    description: "api key detail, one secret",
  },
  addSecret: {
    id: "laXJH7",
    defaultMessage: "Add secret",
    description: "api key detail, button",
  },
  secretLimitHint: {
    id: "OSd3Uo",
    defaultMessage: "A key has at most two secrets. Delete the old one to add another.",
    description: "api key detail, hint beside a disabled Add secret",
  },
  noSecrets: {
    id: "xxjnca",
    defaultMessage: "This key has no secrets, so nothing can use it. Add one to use it again.",
    description: "api key detail, no secrets",
  },
  deleteSecret: {
    id: "g00AwN",
    defaultMessage: "Delete secret",
    description: "api key detail, button and dialog title",
  },
  deleteSecretContent: {
    id: "VflnxZ",
    defaultMessage:
      "Delete the secret ending in {lastFour}? Anything still using it is refused from its next request.",
    description: "api key detail, delete secret confirmation",
  },
  deleteLastSecretContent: {
    id: "Bra60T",
    defaultMessage:
      "Delete the secret ending in {lastFour}? It is this key's only secret, so the key stops working until you add another.",
    description: "api key detail, delete the only secret confirmation",
  },
  revoke: {
    id: "hcgkMY",
    defaultMessage: "Revoke key",
    description: "api key detail, button and dialog title",
  },
  revokeConfirm: {
    id: "mDXsaa",
    defaultMessage: "Revoke",
    description: "api key detail, revoke dialog confirm button",
  },
  revokeContent: {
    id: "uhI/Je",
    defaultMessage:
      'Revoke "{label}"? Every secret stops working from the next request. This is permanent: a revoked key cannot be restored or changed.',
    description: "api key detail, revoke confirmation",
  },
  dangerTitle: {
    id: "Neh4cU",
    defaultMessage: "Revoke",
    description: "api key detail, revoke card title",
  },
  dangerDescription: {
    id: "s+QvsR",
    defaultMessage: "Stops the key for good. To pause it instead, set an expiry date.",
    description: "api key detail, revoke card description",
  },
  exceeded: {
    id: "OBndx1",
    defaultMessage:
      "This key has permissions you do not have, so only someone who has all of them can change it, add or delete its secrets, or revoke it.",
    description: "api key detail, notice when the key is wider than the viewer",
  },
});

export const usageMessages = defineMessages({
  title: {
    id: "8Gy50K",
    defaultMessage: "Usage, last 30 days",
    description: "api key detail, usage card title",
  },
  description: {
    id: "d+IWLk",
    defaultMessage: "UTC days, from the request log's daily totals.",
    description: "api key detail, usage card description",
  },
  day: {
    id: "Z1m8b8",
    defaultMessage: "Day",
    description: "api key usage, column",
  },
  requests: {
    id: "B9s6jm",
    defaultMessage: "Requests",
    description: "api key usage, column and total",
  },
  errors: {
    id: "Dwa0af",
    defaultMessage: "Errors",
    description: "api key usage, column and total: client plus server errors",
  },
  throttled: {
    id: "fWSNFo",
    defaultMessage: "Throttled",
    description: "api key usage, column and total: answered 429",
  },
  cost: {
    id: "9oK9yo",
    defaultMessage: "Query cost",
    description: "api key usage, column and total",
  },
  latency: {
    id: "PLdzd/",
    defaultMessage: "Mean latency",
    description: "api key usage, column and total",
  },
  none: {
    id: "5tgeCn",
    defaultMessage: "No requests in the last 30 days.",
    description: "api key usage, empty",
  },
});

export const secretDialogMessages = defineMessages({
  createdTitle: {
    id: "87qBfE",
    defaultMessage: "Copy the key's secret",
    description: "api key secret dialog title, after create",
  },
  rotatedTitle: {
    id: "HOaCBO",
    defaultMessage: "Copy the new secret",
    description: "api key secret dialog title, after add secret",
  },
  warning: {
    id: "VQ/Yd5",
    defaultMessage:
      "You will not see this secret again. Copy it now and give it to the key's holder; if it is lost, add a new secret and delete this one.",
    description: "api key secret dialog, shown-once warning",
  },
  rotatedHint: {
    id: "ZuCjmt",
    defaultMessage:
      "The old secret keeps working. Once the holder uses the new one, delete the old one.",
    description: "api key secret dialog, after add secret",
  },
  secret: {
    id: "CrIp+l",
    defaultMessage: "Secret",
    description: "api key secret dialog, label",
  },
  header: {
    id: "q4RVOQ",
    defaultMessage: "Send it with every request to the store's GraphQL API as",
    description: "api key secret dialog, label above the Authorization header example",
  },
  copySecret: {
    id: "sniC56",
    defaultMessage: "Copy secret",
    description: "button",
  },
  copyHeader: {
    id: "KbrTXj",
    defaultMessage: "Copy header",
    description: "button",
  },
  copied: {
    id: "J+QCd1",
    defaultMessage: "Copied",
    description: "button, after copying",
  },
  done: {
    id: "K+zSYr",
    defaultMessage: "I have copied it",
    description: "api key secret dialog, close button",
  },
});
